<script setup>
    import { reactive, watch, computed } from 'vue'
    import utilFunctions from "../../firebase_settings/utils.js"

    const emit = defineEmits(['executeMethod']);
    //親コンポーネントから受け継いだ契約担当者情報
    const props = defineProps({
        PersonObject: {
            type: Object,
            require: true
        },
    });
    //リアクティブオブジェクト
    const reactiveObj = reactive({
        //契約担当者名
        ContractPerson: '',
        //契約担当者のメールアドレス
        Email: ''
    })
    //全ての入力フォームが入力されたときに変更ボタンを活性化させる
    const inputSomeData = () => {
        //変更ボタンの活性化フラグ
        let equalFlag = false
        //全ての入力フォームが入力されたときに変更ボタンの活性化フラグをTrueにする
        if((reactiveObj.ContractPerson && reactiveObj.ContractPerson != props.PersonObject.ContractPerson) || (reactiveObj.Email && reactiveObj.Email != props.PersonObject.Email)) {
            equalFlag = true
        }
        //活性判定フラグTrueなら変更ボタンを活性化そうでないなら非活性化
        equalFlag ? document.getElementById('commonButtonContractChange').disabled = false: document.getElementById('commonButtonContractChange').disabled = true
    }
    //リアクティブオブジェクトのリセット
    const valueReset = () => {
        reactiveObj.ContractPerson = ''
        reactiveObj.Email = ''
    }
    //モーダルウィンドウが閉じるときに実行
    const exitModal = (editFlag) => {
        const PersonObject = {}
        if(editFlag) {
            //各項目に関して変更があるかチェックを行う
            for(let key of Object.keys(reactiveObj)) {
                //値が入力かつ親コンポーネントから受け取った値と異なっている
                if(reactiveObj[key] && reactiveObj[key] != props.PersonObject[key]) {
                    PersonObject[key] = reactiveObj[key]
                }
            }
            //メールアドレスを正規表現でチェック
            if(PersonObject.Email && !utilFunctions.mailValidation(PersonObject.Email)) {
                return
            }
        }
        //親コンポーネントに編集の是非とその値を渡す
        emit('executeMethod', editFlag, PersonObject);
        //モーダルウィンドウを閉じる際に追加ボタンを非活性化
        document.getElementById('commonButtonContractChange').disabled = true;
        valueReset()
    }
    //契約担当者に関する算出プロパティ
    const getContractPerson = computed({
        get: () => {
            return props.PersonObject.ContractPerson
        },
        set: (value) => {
            reactiveObj.ContractPerson = value
            document.getElementById('ContractPerson').value = value
        }
    })
    //恵沢担当者のメールアドレスに関する算出プロパティ
    const getEmail = computed({
        get: () => {
            return props.PersonObject.Email
        },
        set: (value) => {
            reactiveObj.Email = value
            document.getElementById('Email').value = value
        }
    })
    //リアクティブオブジェクトの監視
    watch(reactiveObj, () => {
        inputSomeData()
    })
</script>

<template>
    <div class="modalArea">
        <div id="modalContent" class="modal">
            <p class="modalTitle">ご契約情報の変更</p>
            <div class="modalInfo">
                <p>ご担当者様</p>
                <input type="text" class="modalInput" id="ContractPerson" v-model="getContractPerson" placeholder="担当者名">
            </div>
            <div class="modalInfo">
                <p>メールアドレス</p>
                <input type="text" class="modalInput" id="Email" v-model="getEmail" placeholder="aaa@cotofure.com">
            </div>
            <button type="button" id="commonButtonContractChange" @click="exitModal(true)" disabled>変更する</button>
        </div>
        <div class="modalOverlay" @click.self="exitModal(false)"></div>
    </div>
</template>

<style scoped>
    .modal {
        width: 800px;
        height: 350px;
        top: 50%;
        left: 50%;
    }
    #commonButtonContractChange {
        width: 190px;
        height: 70px;
        top: 50px;
        left: 50%;
    }
    .modalInfo {
        display: flex;
        flex-direction: row;
        padding: 0 3% 0 3%;
    }
    .modalInput {
        height: 50px;
        width: 500%;
        border-radius: 10px;
        border: solid 3px #d7d7d7;
        background-color: #d7d7d7;
    }
    @media (max-width: 1000px) {
        .modal {
            width: 85%;
            height: auto;
            display: flex;
            justify-content: left;
            align-items: left;
            overflow-y: scroll;
            overflow-x: hidden;
        }
        .modal p {
            padding: 10px 0 10px 0;
        }
        .modalInfo {
            flex-direction: column;
            padding: 3% 0 3% 0;
        }
        .modalInfo p {
            top: 0%;
            width: 100%;
            max-width: 100%;
            font-size: 16px;
        }
        .modalInput {
            height: 50px;
            width: 100%;
            border-radius: 10px;
            border: solid 3px #d7d7d7;
            background-color: #d7d7d7;
        }
        #commonButtonContractChange {
            margin: 20px 0 20px 0;
            top: 30px;
            height: auto;
        }
    }
</style>